import { render, staticRenderFns } from "./AtualizarAtestados.vue?vue&type=template&id=60cba5be&"
import script from "./AtualizarAtestados.vue?vue&type=script&lang=js&"
export * from "./AtualizarAtestados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports